module.exports = __webpack_public_path__ + "img/1440.5574cf9f.jpg";